import React from 'react';

export default function About(props) {
    // eslint-disable-next-line
    let myStyle = {
        color: props.mode==='light'?'#042743':'white',
        backgroundColor: props.mode==='light'?'white':'#042743',
        borderBottom: props.mode==='light'?'1px solid #dfdfdf':'1px solid white'
    }
    document.title = props.title;
  return (
    <div className="container">
        <h2 className='my-3' style={{color: props.mode==='light'?'#042743':'white'}}>ZeeUtils Features</h2>
        <div>
            <p>ZeeUtils is your one-stop solution for all your text processing needs. Whether you're a writer, a student, or just someone who works with text regularly, ZeeUtils has got you covered. With a wide range of handy text manipulation tools, ZeeUtils simplifies your tasks and enhances your productivity. Let's take a closer look at some of its powerful features:</p>

            <h4>Word Counter</h4>
            <p>Quickly count the number of words in your text to keep track of your writing progress.</p>

            <h4>Character Counter</h4>
            <p>Need to know how many characters are in your document? ZeeUtils can count them for you.</p>

            <h4>Remove Extra Spaces</h4>
            <p>Clean up your text by eliminating unnecessary spaces and ensuring it looks polished.</p>

            <h4>Convert to Capitalize</h4>
            <p>Capitalize the first letter of every word to give your text a professional and polished appearance.</p>

            <h4>Convert to Uppercase</h4>
            <p>Transform your text into uppercase for emphasis or formatting consistency.</p>

            <h4>Convert to Lowercase</h4>
            <p>Make your text all lowercase for a more casual or standardized look.</p>

            <h4>Clear Text</h4>
            <p>Start with a clean slate by clearing all the text in the input field.</p>

            <h4>Copy Text</h4>
            <p>Easily copy your modified text to the clipboard for quick pasting.</p>

            <h4>Replace Spaces with Dashes</h4>
            <p>Swap spaces for dashes, ideal for creating web-friendly URLs.</p>

            <h4>Replace Dashes with Spaces</h4>
            <p>Need to reverse the process? ZeeUtils can replace dashes with spaces.</p>

            <h4>Repeat Text 5x</h4>
            <p>Quickly generate repeated text for whatever purpose you may have.</p>

            <h4>Reverse Text</h4>
            <p>Flip your text in reverse order for fun or encryption purposes.</p>

            <h4>Text to Binary</h4>
            <p>Convert your text into binary code, perfect for encoding secrets or binary data.</p>

            <h4>Text Encode Base64</h4>
            <p>Encode your text using Base64 encoding for secure transmission or storage.</p>

            <h4>Text Decode Base64</h4>
            <p>Decode Base64-encoded text to retrieve the original content.</p>

            <h4>Add Line Numbers</h4>
            <p>Automatically number the lines in your text, making it easier to reference specific sections.</p>

            <h4>Split by Capital & Moved to Next Line</h4>
            <p>Split your text wherever capital letters appear and move them to the next line. Useful for text formatting.</p>

            <h4>Split by Capital with Space</h4>
            <p>Similar to the previous feature but with spaces added after each split point.</p>

            <p>No matter what text-related task you have at hand, ZeeUtils is here to simplify it. Try it out today and experience the convenience and efficiency of this versatile text processing tool. Say goodbye to manual text editing and hello to ZeeUtils!</p>
        </div>
        {/* <div className="accordion" id="accordionExample">
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={myStyle}>
                    <strong>Analyze Your text </strong>
                </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body" style={myStyle}>
                    ZeeUtils gives you a way to analyze your text quickly and efficiently. Be it word count, character count.
                </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={myStyle}>
                    <strong>Free to use </strong>
                </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div className="accordion-body" style={myStyle}>
                    ZeeUtils is a free character counter tool that provides instant character count &amp; word count statistics for a given text. ZeeUtils reports the number of words and characters. Thus it is suitable for writing text with word/ character limit.
                </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={myStyle}>
                    <strong>Browser Compatible </strong>
                </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div className="accordion-body" style={myStyle}>
                    This word counter software works in any web browsers such as Chrome, Firefox, Internet Explorer, Safari, Opera. It suits to count characters in facebook, blog, books, excel document, pdf document, essays, etc.
                </div>
                </div>
            </div>
        </div> */}
    </div>
  )
}
